<mat-card class="example-card">
    <mat-card-header class="titreFrm ">
      <mat-card-title>CONG&Eacute;</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <!------------ bare de chargement ----------------->
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <mat-card >  
          <h4>Liste des demandes, il vous reste <b>{{nbrJourCongeRestant}}</b></h4>
          <div class="display-Flex-3">
            <div>
              <mat-form-field class="width-125"    appearance="outline" >
                <mat-label>Du</mat-label>
                <input matInput [matDatepicker]="dateDebut" placeholder="Du" name="def" #def="ngModel" [(ngModel)]="date_Debut">
                <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
                <mat-datepicker #dateDebut></mat-datepicker>
              </mat-form-field>
    
              <mat-form-field  class="width-125"   appearance="outline" >
                <mat-label>Au</mat-label>
                <input matInput [matDatepicker]="dateFin" placeholder="Au" name="abc" [(ngModel)]="date_Fin">
                <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
                <mat-datepicker #dateFin></mat-datepicker>
              </mat-form-field>          
            </div>
            <div>
              <button (click)="getListeConger()" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>search</mat-icon>Filtrer</button>
              <button (click)="openFrmConger('ajouter')" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>add</mat-icon>Ajouter</button>
              <button (click)="modierConge()" [disabled]="!exist" mat-raised-button class="colorBlue"><mat-icon>edite</mat-icon>Modifier</button>
              <button (click)="suprrimerConge()" [disabled]="!exist" mat-raised-button class="colorRed"><mat-icon>save</mat-icon>Supprimer</button>
            </div>
          </div>


        <app-liste #listeCongeConmponent  [dataSource]="listeConger" [columns]="columns"></app-liste>

      </mat-card>
    </mat-card-content>
</mat-card>
<ng-template #frmConge>
  
  <mat-card>
    <form #formConge="ngForm">
      <div class="display-Flex-2">
        <button (click)="closeFrmConge()" mat-raised-button  class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
        <button (click)="enregistrer(formConge)" [disabled]="!exist" mat-raised-button  class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
      </div>
      <mat-form-field     appearance="outline"  class="width-150">
        <mat-label>Nature</mat-label>
        <mat-select name="Conge_Nature" #Conge_Nature="ngModel" [(ngModel)]="conge.Conge_Nature" placeholder="Nature" required>
        <mat-option *ngFor="let Conge_Nature of listeCongeNature" [value]="Conge_Nature.DiverSys_Index">
            {{Conge_Nature.DiverSys_Titre}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field     appearance="outline"  class="width-125">
          <mat-label>Date débu</mat-label>
          <input matInput name="Conge_DateDebut"
              (dateChange)="calculerConge_NbrJour()"
              #Conge_DateDebut="ngModel" [(ngModel)]="conge.Conge_DateDebut" [matDatepicker]="picker4"
              placeholder="Date début" required>
          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
          <mat-datepicker #picker4></mat-datepicker>
      </mat-form-field>
      <mat-form-field     appearance="outline"  class="width-125">
          <mat-label>Date fin</mat-label>
          <input matInput name="Conge_DateFin"
              (dateChange)="calculerConge_NbrJour()"
              #Conge_DateFin="ngModel" [(ngModel)]="conge.Conge_DateFin" [matDatepicker]="picker3"
              placeholder="Date fin" required>
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>
      <mat-form-field     appearance="outline"  class="width-80">
          <mat-label>Nbr.jours</mat-label>
          <input matInput name="Conge_NbrJour" [(ngModel)]="conge.Conge_NbrJour" #Conge_NbrJour="ngModel" placeholder="Nbr.jours">
      </mat-form-field>
    </form>    
  </mat-card>
</ng-template>